export default {
    loginTitle: "Bon retour parmi nous",
    loginDescription: "Poursuivez votre apprentissage des langues. Connectez-vous pour accéder à votre tableau de bord et à vos tests.",
    callToRegisterActionLabel: "Vous n'avez pas de compte ?",
    callToLoginActionLabel: "Vous avez déjà un compte ?",
    registerActionLabel: "Commencer",
    registerActionButtonLabel: "Créer mon compte",
    loginActionLabel: "Se connecter",
    callToResetPasswordActionLabel: "Mot de passe oublié ?",
    registerFormTitle: "Créez votre compte",
    registerFormDescription: "Commencez votre parcours vers la maîtrise des langues",
    previousRegistrationStepActionLabel: "Précédent",
    nextRegistrationStepActionLabel: "Suivant",
    googleRegistrationActionLabel: "S'inscrire Google",
    facebookRegistrationActionLabel: "S'inscrire Facebook",
    googleLoginActionLabel: "Se connecter avec Google",
    facebookLoginActionLabel: "Se connecter avec Facebook",

    forgotPasswordTitle: "Mot de passe oublié ?",
    forgotPasswordDescription: "Saisissez l'adresse email de votre compte et nous vous enverrons un lien pour choisir un nouveau mot de passe.",
    sendResetLinkActionLabel: "Envoyer le lien",
    backToLoginActionLabel: "Retour à la connexion",
    resetPasswordTitle: "Choisissez un nouveau mot de passe",
    resetPasswordDescription: "Choisissez un mot de passe que vous n'avez jamais utilisé sur ce compte.",
    resetPasswordActionLabel: "Réinitialiser le mot de passe",
    resetPasswordEmailSentTitle: "Consultez votre boîte de réception",
    resetPasswordEmailSentDescription: "Si {{email}} correspond à un compte, un lien de réinitialisation est en route. Le lien expire dans 60 minutes.",
    resetPasswordSuccessTitle: "Mot de passe mis à jour",
    resetPasswordSuccessDescription: "Votre mot de passe a été modifié et vous avez été déconnecté de tous vos autres appareils.",
    passwordTooShortMessage: "Le mot de passe doit contenir au moins {{count}} caractères.",

    verifyEmailLoadingMessage: "Vérification de votre adresse email...",
    verifyEmailSuccessTitle: "Email vérifié",
    verifyEmailSuccessDescription: "Merci — votre adresse email est confirmée et votre compte est pleinement actif.",
    verifyEmailFailedTitle: "Nous n'avons pas pu vérifier ce lien",
    verifyEmailBannerTitle: "Vérifiez votre adresse email",
    verifyEmailBannerDescription: "Nous avons envoyé un lien de confirmation à {{email}}. Vérifiez-le pour conserver l'accès complet à votre compte.",
    resendVerificationEmailActionLabel: "Renvoyer l'email",
}
